import { render } from "./DetalharTimes.vue?vue&type=template&id=fc63550c&scoped=true"
import script from "./DetalharTimes.vue?vue&type=script&lang=js"
export * from "./DetalharTimes.vue?vue&type=script&lang=js"

import "./DetalharTimes.vue?vue&type=style&index=0&id=fc63550c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc63550c"]])

export default __exports__